// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3e3100e6","498":"adeeccc9","703":"99312973"}[chunkId] + ".chunk.js";
};